import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import './PagePreview.css';
import Page from '../page/Page';
import {
  orderBy,
  GetActivePage,
  hideComponent,
} from './../../redux/helpers';
import {
  getPageLayoutByType,
  getInnerPagesLayouts,
} from './../../redux/helpers/layouts';
import ScrollArrow from '../scroll-arrow/ScrollArrow';
import { getPlaceholders } from '../../redux/helpers/pages';

const SortableItem = SortableElement(({
  order,
  active,
  maxPages,
  pageId,
  isChange,
  isCover,
  placeholders,
  pages,
  images,
  backgroundColor,
  lang,
  backgroundImages,
  ratio,
}) => (
  <Page
    active={active}
    pageData={{
        all: maxPages,
        current: order + 1,
        order,
      }}
    width={65 * ratio}
    height={65}
    pages={pages}
    pageId={pageId}
    isChange={isChange}
    isCover={isCover}
    placeholders={placeholders}
    images={images}
    backgroundColor={backgroundColor}
    backgroundImage={backgroundImages ? encodeURI(backgroundImages.thumbnail) : ''}
    lang={lang}
  />
));

const SortableList = SortableContainer(({
  items, maxPages, pages, isChange, isCover, placeholders, images, lang, bookProperties,
}) => (

  <div className="sortable-list">
    {items.map((sheet, key) => {
      const bookWidth = bookProperties.width;
      const bookHeight = bookProperties.height;

      const layoutRatio = bookWidth / bookHeight;

      return (
        <SortableItem
          key={key}
          index={sheet.order}
          order={sheet.order}
          pages={pages.byId}
          maxPages={maxPages}
          active={sheet.isActive}
          pageId={sheet.id}
          ratio={layoutRatio}
          isChange={isChange}
          disabled
          isCover={isCover}
          placeholders={getPlaceholders(sheet, placeholders, pages, images)}
          images={images}
          backgroundColor={sheet.backgroundColor}
          backgroundImages={sheet.backgroundImages}
          lang={lang}
        />
      );
      })}
  </div>
));

class PagePreview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayTopArrow: false,
      displayBottomArrow: false,
      hideComponent: false,
    };
  }

  componentWillMount() {
    if (hideComponent()) {
      this.setState({
        hideComponent: true,
      });
    }
    const { autofillFinished } = this.props;
    if (!this.state.displayBottomArrow && autofillFinished) {
      this.toggleBottomArrow(true);
    }
  }

  componentDidMount() {
    this.toggleArrow();
  }

  shouldComponentUpdate(nextProps) {
    const isAutofillFinishedOrNormalBook = (nextProps.autofillFinished && nextProps.isAutofill) || !nextProps.isAutofill;
    if (isAutofillFinishedOrNormalBook) {
      return true;
    }

    return false;
  }


  componentWillUpdate(nextProps) {
    const { allIds } = this.props.pages;
    const { allIds: nextallIds } = nextProps.pages;
    if (nextallIds.length !== allIds.length) {
      setTimeout(() => {
        this.toggleArrow();
      }, 0);
    }
  }


  generatePreview = (pageType) => {
    const {
      pages,
      isChange,
      images,
      placeholders,
      lang,
      layouts,
      bookProperties,
      coverColor,
    } = this.props;
    const {
      byId,
      allIds,
    } = pages;
    const getPageType = getPageLayoutByType(byId, pageType);

    if (!getPageType) {
      return false;
    }

    const {
      isActive,
      order,
      id,
      backgroundColor,
      backgroundImages,
    } = getPageType;

    const getPlaceholdersByPageType = getPlaceholders(getPageType, placeholders, pages, images.byId);
    const { isCover } = GetActivePage(byId);

    const layoutProperties = layouts[getPageType.layout];
    const layoutHeight = layoutProperties && 'height' in layoutProperties ? layoutProperties.height : bookProperties.height;
    const layoutWidth = layoutProperties && 'width' in layoutProperties ? layoutProperties.width : bookProperties.width;

    const layoutRatio = layoutWidth / layoutHeight;

    return (
      <Page
        active={isActive}
        pageData={{
          all: allIds.length,
          current: pageType === 'isBackFlyLeaf' ? allIds.length : order + 1,
          order,
        }}
        width={65 * layoutRatio}
        height={65}
        pageId={id}
        isChange={isChange}
        isCover={isCover}
        placeholders={getPlaceholdersByPageType}
        images={images.byId}
        pages={pages.byId}
        backgroundColor={getPageType.isCover ? coverColor : backgroundColor}
        backgroundImage={backgroundImages ? encodeURI(backgroundImages.thumbnail) : ''}
        lang={lang}
      />
    );
  }

  toggleTopArrow = (visible) => {
    this.setState({
      displayTopArrow: visible,
    });
  }

  toggleBottomArrow = (visible) => {
    this.setState({
      displayBottomArrow: visible,
    });
  }

  displayArrow = (direction, target, state, className) => (
    state ?
      <ScrollArrow
        direction={direction}
        classes={`${className} galleryScroll`}
        target={target}
        vertical
      />
      :
      ''
  )

  toggleArrow = () => {
    if (this.refs.scrollWrapper) {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth,
      } = this.refs.scrollWrapper;

      if (scrollLeft > 0) {
        this.toggleTopArrow(true);
      }

      if (scrollLeft === 0) {
        this.toggleTopArrow(false);
      }


      if (scrollLeft + clientWidth === scrollWidth) {
        this.toggleBottomArrow(false);
      }

      if (scrollLeft + clientWidth !== scrollWidth) {
        this.toggleBottomArrow(true);
      }

      if (this.props.autofillFinished) {
        this.toggleBottomArrow(true);
      }
    }
  }

  shouldCancelStart(isAutofill) {
    if (isAutofill) {
      return true;
    }
    return false;
  }

  render() {
    const {
      pages,
      isChange,
      placeholders,
      images,
      lang,
      bookProperties,
    } = this.props;
    const innerPages = getInnerPagesLayouts(pages.byId);
    const pagesArray = orderBy(innerPages, 'order');

    const {
      displayTopArrow,
      displayBottomArrow,
      hideComponent,
    } = this.state;

    const activePage = GetActivePage(pages.byId);
    const { isCover } = activePage;


    return (
      <div className="PagePreview" style={{ height: 97 }} >
        {this.displayArrow('left', '.PagePreview .scroll', displayTopArrow, 'ScrollLeft')}
        <div className="scrollarea-content custom-scrollbar">
          <div className="scroll" ref="scrollWrapper" onScroll={this.toggleArrow.bind(this)}>
            {this.generatePreview('isCover')}
            {this.generatePreview('isFrontFlyLeaf')}
            {this.generatePreview('isBabyPage')}
            <SortableList
              axis="x"
              distance={5}
              items={pagesArray}
              images={images.byId}
              isChange={isChange}
              isCover={isCover}
              lockAxis="x"
              maxPages={pages.allIds.length}
              pages={pages}
              placeholders={placeholders}
              shouldCancelStart={() => this.shouldCancelStart(hideComponent)}
              lang={lang}
              bookProperties={bookProperties}
            />
            {this.generatePreview('isBackFlyLeaf')}
          </div>
        </div>

        {this.displayArrow('right', '.PagePreview .scroll', displayBottomArrow, 'ScrollRight')}
      </div>
    );
  }
}

PagePreview.defaultProps = {
  pages: {},
  isChange: false,
  images: {},
  placeholders: {},
  layouts: {},
  lang: {},
  coverColor: '#ffffff',
  bookProperties: {},
  autofillFinished: false,
};

PagePreview.propTypes = {
  pages: PropTypes.object,
  isChange: PropTypes.bool,
  images: PropTypes.object,
  placeholders: PropTypes.object,
  lang: PropTypes.object,
  layouts: PropTypes.object,
  bookProperties: PropTypes.object,
  coverColor: PropTypes.string,
  autofillFinished: PropTypes.bool,
};

export default connect(state => ({
  pages: state.entities.pages,
  placeholders: state.entities.placeholders,
  images: state.entities.images,
  layouts: state.entities.layouts.byId,
  isChange: state.editorUI.imageChange.isChange,
  bookProperties: state.bookProperties.bookSizes,
  isAutofill: state.bookProperties.autofill,
  coverColor: state.entities.cover.spine.backgroundColor,
  autofillFinished: state.entities.io.autofillFinished,
}))(PagePreview);



// WEBPACK FOOTER //
// ./src/components/page-preview/PagePreview.jsx